<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.66636 6H14.333M6.66636 2L5.33302 6L7.99969 13.6667L10.6664 6L9.33303 2M8.40941 13.5083L14.3818 6.34143C14.4831 6.21997 14.5337 6.15924 14.553 6.09144C14.5701 6.03167 14.5701 5.96833 14.553 5.90856C14.5337 5.84076 14.4831 5.78003 14.3818 5.65857L11.4929 2.1919C11.4342 2.12136 11.4048 2.08609 11.3687 2.06074C11.3368 2.03827 11.3012 2.02159 11.2635 2.01145C11.221 2 11.175 2 11.0832 2H4.91616C4.82434 2 4.77843 2 4.73588 2.01145C4.69819 2.02159 4.66257 2.03827 4.63064 2.06074C4.59461 2.08609 4.56522 2.12136 4.50644 2.1919L1.61755 5.65857C1.51633 5.78003 1.46572 5.84076 1.44638 5.90855C1.42933 5.96833 1.42933 6.03167 1.44638 6.09144C1.46572 6.15924 1.51633 6.21997 1.61755 6.34143L7.58997 13.5083C7.73068 13.6772 7.80103 13.7616 7.88526 13.7924C7.95916 13.8194 8.04023 13.8194 8.11412 13.7924C8.19835 13.7616 8.26871 13.6772 8.40941 13.5083Z"
      stroke="currentColor"
      stroke-width="1.28"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
